/** Animated drop list */
import React, {  useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCheck } from "@fortawesome/free-solid-svg-icons";
import { slideData } from "../../../_helpers/mock-data";
import classNames from "classnames";

import "../drop-list/drp-list.css";
import "./multi.css";

export const MultipleSelect = () => {

    const [selected, setSelected] = useState([]);
    
    const isSelected = (v) => selected.includes(v);
    
    const selectValue = (v) => {
        setSelected((s) => ([...s,v]));
    }

    const unselectValue = (v) => {
        setSelected((s) => s.filter((val) => val !== v));
    }

    const handleSelectValue = (v) => {
        isSelected(v) ? unselectValue(v) : selectValue(v);
    }

    const [active, SetActive] = useState(false);

    const toggleActive = () => SetActive((act) => !act);
  

    return (
     
        <div className="list-container">
            <div className='selected-items'>
                {selected?.map((s) =><div className="item-unit">{s}</div>)}
            </div>
            <div className={classNames("list-button")} onClick={toggleActive}>
                <span className="button-label">Click to Select values</span>
                <button className={classNames("round-anim", {'active': active})}>
                    <FontAwesomeIcon icon={faCaretDown} />
                </button>
            </div>
            <div className={classNames("anim-bg", {'animed': active})}  />
            <div className={classNames("list-box", {'opened': active})}>
                {slideData.map((d,k) => {
                    return( 
                    <p className="list-unit" key={k}  onClick={() => handleSelectValue(d.caption)}>
                        <div className='select-input'>
                            <FontAwesomeIcon 
                                icon={faCheck} 
                                className={classNames('select-icon',{'clicked': isSelected(d.caption)})} 
                            />
                        </div>
                        <div className='list-value'>{d.caption}</div>
                    </p>)
                })}
            </div>
        </div>
    )
}